import { render, staticRenderFns } from "./CRAddressSelectorV2PrefillItem.vue?vue&type=template&id=c25d091e&scoped=true"
import script from "./CRAddressSelectorV2PrefillItem.vue?vue&type=script&lang=js"
export * from "./CRAddressSelectorV2PrefillItem.vue?vue&type=script&lang=js"
import style0 from "./CRAddressSelectorV2PrefillItem.vue?vue&type=style&index=0&id=c25d091e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c25d091e",
  null
  
)

export default component.exports